/**
 * Sélecteurs pour les paramètres PFS
 */

/**
 * Récupère tous les paramètres PFS
 * @param {Object} state - État Redux global
 * @returns {Object} - Paramètres PFS
 */
export const getPfsParams = state => state.pfsParams || {};

/**
 * Récupère un paramètre PFS spécifique
 * @param {Object} state - État Redux global
 * @param {string} key - Clé du paramètre
 * @returns {string|undefined} - Valeur du paramètre
 */
export const getPfsParam = (state, key) => state.pfsParams?.[key];

/**
 * Vérifie s'il y a des paramètres PFS
 * @param {Object} state - État Redux global
 * @returns {boolean} - True s'il y a des paramètres
 */
export const hasPfsParams = state => {
	const params = getPfsParams(state);
	return Object.keys(params).length > 0;
};
